import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { getC3StaticDataColumns, type C3StaticDatum } from "./columns";
import { type FilterC3StaticDatumsSchema, FilterC3StaticData } from "./filter";

export const C3StaticDataTable = () => {
  const { t } = useTranslation();
  const columns = getC3StaticDataColumns(t);

  return (
    <Table<C3StaticDatum, FilterC3StaticDatumsSchema>
      label={t("c3_static_data.title", {
        ns: "tables",
        defaultValue: "Actifs financiers",
      })}
      client={Clients.C3}
      table_name={Tables.C3_STATIC_DATA}
      columns={columns}
      filter={<FilterC3StaticData />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.C3}/${Tables.C3_STATIC_DATA}/new`,
        },
      ]}
    />
  );
};
